<template>
  <span class="badge" :class="{ 'badge--primary': primary }">
    <span
      v-if="icon"
      class="badge__icon iconfont"
      :class="icon"
      aria-hidden="true"
    />
    <slot />
  </span>
</template>

<script setup lang="ts">
defineProps<{
  /**
   * Iconfont class, e.g. `iaudio`.
   */
  icon?: string
  /**
   * Use the filled blue style, e.g. for the "Free" badge.
   */
  primary?: boolean
}>()
</script>

<style lang="scss" scoped>
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 2px 8px 0;
  border: 1px solid $c-black-4;
  border-radius: 8px;
  background: $c-bg;
  color: $c-black-9;
  font-size: 12px;
  line-height: 18px;

  &--primary {
    border-color: $c-white;
    background: $c-blue-4;
    color: $c-white;
  }

  &__icon {
    font-size: 22px;
    line-height: 22px;
  }
}

.night-mode .badge {
  border-color: $c-dark-5;
  background: transparent;
  color: $c-dark-8;

  &--primary {
    border-color: $c-dark-4;
    background: $c-blue-4;
    color: $c-white;
  }
}
</style>
